"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TectonicStakingPoolStorageV2Factory = void 0;
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "allowedConversionCallers",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "withdrawalExchangeRates",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
const _bytecode = "0x608060405234801561001057600080fd5b5060f88061001f6000396000f3fe6080604052348015600f57600080fd5b506004361060325760003560e01c80632015146514603757806341a3c9b414606c575b600080fd5b605760423660046096565b60006020819052908152604090205460ff1681565b60405190151581526020015b60405180910390f35b608960773660046096565b60016020526000908152604090205481565b6040519081526020016063565b60006020828403121560a6578081fd5b81356001600160a01b038116811460bb578182fd5b939250505056fea264697066735822122008b1cce612b06b805daf544de8ea921deaac6f2faf388ecfb6acfefd179377d664736f6c63430008030033";
class TectonicStakingPoolStorageV2Factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (args.length === 1) {
            super(_abi, _bytecode, args[0]);
        }
        else {
            super(...args);
        }
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.TectonicStakingPoolStorageV2Factory = TectonicStakingPoolStorageV2Factory;
TectonicStakingPoolStorageV2Factory.bytecode = _bytecode;
TectonicStakingPoolStorageV2Factory.abi = _abi;
//# sourceMappingURL=TectonicStakingPoolStorageV2Factory.js.map